"use strict";
'use client';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Address = void 0;
var _camelCase = _interopRequireDefault(require("lodash/camelCase"));
var _find = _interopRequireDefault(require("lodash/find"));
var _get = _interopRequireDefault(require("lodash/get"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _Form = _interopRequireDefault(require("../../components/form/Form"));
var _Button = require("../../elements/button/Button");
var _addressSearch = require("../../form/configs/addressSearch");
var _addressActions = require("../../redux/actions/address/addressActions");
var _countries = _interopRequireDefault(require("../../utils/content/countries"));
var _AddressForm = _interopRequireDefault(require("../address-form/AddressForm"));
var _Message = require("../message/Message");
var _addressWithSearchFormModule = _interopRequireDefault(require("./address-with-search-form.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Address = exports.Address = /*#__PURE__*/function (_Component) {
  function Address() {
    var _this;
    _classCallCheck(this, Address);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Address, [].concat(args));
    _defineProperty(_this, "onSearchForAnotherAddress", function () {
      var _this$props = _this.props,
        addressId = _this$props.addressId,
        resetAddressSearch = _this$props.resetAddressSearch,
        onSearchForAnotherAddressOverride = _this$props.onSearchForAnotherAddressOverride,
        countryCode = _this$props.countryCode;
      if (onSearchForAnotherAddressOverride) {
        return onSearchForAnotherAddressOverride({
          addressId: addressId,
          countryCode: countryCode
        });
      }
      return resetAddressSearch({
        addressId: addressId
      });
    });
    _defineProperty(_this, "onEnterManualAddress", function () {
      var _this$props2 = _this.props,
        addressId = _this$props2.addressId,
        enterManualAddress = _this$props2.enterManualAddress,
        onEnterManualAddress = _this$props2.onEnterManualAddress;
      enterManualAddress({
        addressId: addressId
      });
      onEnterManualAddress();
    });
    _defineProperty(_this, "onEnterInternationalAddress", function () {
      var _this$props3 = _this.props,
        addressId = _this$props3.addressId,
        enterManualAddress = _this$props3.enterManualAddress,
        onEnterManualAddress = _this$props3.onEnterManualAddress;
      enterManualAddress({
        addressId: addressId,
        international: true,
        countryCode: ''
      });
      onEnterManualAddress();
    });
    _defineProperty(_this, "onAddressFormSubmitFailed", function () {
      var _this$props4 = _this.props,
        addressId = _this$props4.addressId,
        resetFindAddressError = _this$props4.resetFindAddressError;
      resetFindAddressError({
        addressId: addressId
      });
    });
    _defineProperty(_this, "onAddressFormSubmit", function (formData) {
      var onAddressFormSubmit = _this.props.onAddressFormSubmit;
      return onAddressFormSubmit(formData);
    });
    return _this;
  }
  _inherits(Address, _Component);
  return _createClass(Address, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props5 = this.props,
        addressId = _this$props5.addressId,
        international = _this$props5.international,
        enterManualAddress = _this$props5.enterManualAddress,
        regionCode = _this$props5.regionCode,
        countryCode = _this$props5.countryCode;
      if (international && !countryCode && regionCode && regionCode !== 'GB') {
        setTimeout(function () {
          enterManualAddress({
            addressId: addressId,
            international: true,
            countryCode: regionCode
          });
        }, 0);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props6 = this.props,
        addressId = _this$props6.addressId,
        internationalMode = _this$props6.internationalMode,
        countryCode = _this$props6.countryCode,
        resetAddressSearch = _this$props6.resetAddressSearch,
        canEnterUKAddressInInternationalMode = _this$props6.canEnterUKAddressInInternationalMode;
      var hasUnitedKingdomBeenSelectedFromCountrySelector = !canEnterUKAddressInInternationalMode && internationalMode && countryCode === 'GB' && prevProps.countryCode !== countryCode;
      if (hasUnitedKingdomBeenSelectedFromCountrySelector) {
        resetAddressSearch({
          addressId: addressId,
          countryCode: countryCode
        });
        return;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props7 = this.props,
        findAddressError = _this$props7.findAddressError,
        formId = _this$props7.formId,
        getConfig = _this$props7.getConfig,
        configExtras = _this$props7.configExtras,
        international = _this$props7.international,
        internationalMode = _this$props7.internationalMode,
        destroyOnUnmount = _this$props7.destroyOnUnmount,
        renderPostcodeSearchBeforeAddressForm = _this$props7.renderPostcodeSearchBeforeAddressForm,
        useFormValidationErrorsAlertMessage = _this$props7.useFormValidationErrorsAlertMessage,
        showAddressSearchForm = _this$props7.showAddressSearchForm,
        initialValues = _this$props7.initialValues,
        multiFormValidation = _this$props7.multiFormValidation,
        regionCode = _this$props7.regionCode,
        loqateApiKey = _this$props7.loqateApiKey,
        addressId = _this$props7.addressId,
        addressSearchInputId = _this$props7.addressSearchInputId,
        validateLoqateAddress = _this$props7.validateLoqateAddress,
        onLoqateSearch = _this$props7.onLoqateSearch,
        getLoqateMocks = _this$props7.getLoqateMocks,
        shouldMockLoqate = _this$props7.shouldMockLoqate,
        preventLoqateScroll = _this$props7.preventLoqateScroll,
        onLoqateTimeoutEnterAddressManuallyCallback = _this$props7.onLoqateTimeoutEnterAddressManuallyCallback,
        onLoqateNetworkTimeoutCallback = _this$props7.onLoqateNetworkTimeoutCallback,
        showSelectBelowOnEnterMessage = _this$props7.showSelectBelowOnEnterMessage,
        countryCode = _this$props7.countryCode,
        jlpid = _this$props7.jlpid,
        extraSearchAction = _this$props7.extraSearchAction,
        replaceGbTerritoryCountryCodes = _this$props7.replaceGbTerritoryCountryCodes,
        combineExtraAddressLines = _this$props7.combineExtraAddressLines,
        maxAddressLines = _this$props7.maxAddressLines,
        scrollValidationMessageIntoView = _this$props7.scrollValidationMessageIntoView;
      var addressSearchConfig = (0, _addressSearch.getAddressSearchConfig)(addressId, addressSearchInputId, this.onEnterManualAddress, loqateApiKey, validateLoqateAddress, onLoqateSearch, getLoqateMocks, preventLoqateScroll, onLoqateTimeoutEnterAddressManuallyCallback, shouldMockLoqate, onLoqateNetworkTimeoutCallback, jlpid, extraSearchAction, replaceGbTerritoryCountryCodes, combineExtraAddressLines, maxAddressLines);
      var postcodeSearchComponent = /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [showSelectBelowOnEnterMessage && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Message.Message, {
          type: "error",
          title: (0, _get["default"])(showSelectBelowOnEnterMessage, 'title', 'Please keep typing to find an address')
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Form["default"], {
          config: addressSearchConfig,
          "data-testid": "address-search-form",
          form: addressSearchConfig.id,
          formValidationErrorsAlertMessage: {
            title: 'Please keep typing to find an address'
          }
        })]
      });
      var postcodeSearch = showAddressSearchForm ? postcodeSearchComponent : null;
      var newConfigExtras = !findAddressError ? configExtras : _objectSpread(_objectSpread({}, configExtras), {}, {
        error: findAddressError
      });
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: _addressWithSearchFormModule["default"].container,
        "data-jlds": true,
        children: [renderPostcodeSearchBeforeAddressForm && postcodeSearch, /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: _addressWithSearchFormModule["default"].addressForm,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_AddressForm["default"], {
            dataTestId: "address-form",
            formId: formId,
            getConfig: getConfig,
            configExtras: newConfigExtras,
            initialValues: initialValues,
            destroyOnUnmount: destroyOnUnmount,
            international: international,
            internationalMode: internationalMode,
            onFormSubmit: this.onAddressFormSubmit,
            onFormSubmitFailed: this.onAddressFormSubmitFailed,
            onSearchForAnotherAddress: this.onSearchForAnotherAddress,
            onSearchUKPostcode: this.onSearchForAnotherAddress,
            postcodeSearchFormVisible: showAddressSearchForm,
            useFormValidationErrorsAlertMessage: useFormValidationErrorsAlertMessage,
            multiFormValidation: multiFormValidation,
            regionCode: regionCode,
            maxAddressLines: maxAddressLines,
            scrollValidationMessageIntoView: scrollValidationMessageIntoView
          })
        }), international && showAddressSearchForm && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: _addressWithSearchFormModule["default"].enterInternationalAddressContainer,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h4", {
            children: "Country"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            "data-testid": "address-with-search-form-enter-international-address-current",
            children: (0, _get["default"])((0, _find["default"])(_countries["default"], {
              value: countryCode || regionCode
            }), 'label', 'United Kingdom')
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.UnderlinedButton, {
            onClick: this.onEnterInternationalAddress,
            className: _addressWithSearchFormModule["default"].enterInternationalAddressButton,
            "data-testid": "address-with-search-form-enter-international-address",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              children: "Change"
            })
          })]
        }), !renderPostcodeSearchBeforeAddressForm && postcodeSearch]
      });
    }
  }]);
}(_react.Component);
_defineProperty(Address, "propTypes", {
  findAddressError: _propTypes["default"].shape({}),
  showAddressSearchForm: _propTypes["default"].bool,
  configExtras: _propTypes["default"].objectOf(_propTypes["default"].any),
  formId: _propTypes["default"].string,
  addressId: _propTypes["default"].string,
  addressSearchInputId: _propTypes["default"].string,
  international: _propTypes["default"].bool,
  internationalMode: _propTypes["default"].bool,
  countryCode: _propTypes["default"].string,
  regionCode: _propTypes["default"].string,
  initialValues: _propTypes["default"].objectOf(_propTypes["default"].string),
  destroyOnUnmount: _propTypes["default"].bool,
  renderPostcodeSearchBeforeAddressForm: _propTypes["default"].bool,
  useFormValidationErrorsAlertMessage: _propTypes["default"].bool,
  multiFormValidation: _propTypes["default"].bool,
  canEnterUKAddressInInternationalMode: _propTypes["default"].bool,
  loqateApiKey: _propTypes["default"].string,
  preventLoqateScroll: _propTypes["default"].bool,
  shouldMockLoqate: _propTypes["default"].bool,
  getLoqateMocks: _propTypes["default"].func,
  getConfig: _propTypes["default"].func,
  onAddressFormSubmit: _propTypes["default"].func,
  onSearchForAnotherAddressOverride: _propTypes["default"].func,
  onEnterManualAddress: _propTypes["default"].func,
  validateLoqateAddress: _propTypes["default"].func,
  onLoqateSearch: _propTypes["default"].func,
  onLoqateTimeoutEnterAddressManuallyCallback: _propTypes["default"].func,
  onLoqateNetworkTimeoutCallback: _propTypes["default"].func,
  jlpid: _propTypes["default"].string,
  extraSearchAction: _propTypes["default"].element,
  replaceGbTerritoryCountryCodes: _propTypes["default"].bool,
  combineExtraAddressLines: _propTypes["default"].bool,
  maxAddressLines: _propTypes["default"].number,
  // actions
  resetAddressSearch: _propTypes["default"].func,
  enterManualAddress: _propTypes["default"].func,
  resetFindAddressError: _propTypes["default"].func,
  showSelectBelowOnEnterMessage: _propTypes["default"].shape({}),
  scrollValidationMessageIntoView: _propTypes["default"].bool
});
_defineProperty(Address, "defaultProps", {
  findAddressError: undefined,
  showAddressSearchForm: false,
  configExtras: {},
  formId: '',
  addressId: '',
  addressSearchInputId: '',
  international: false,
  internationalMode: false,
  countryCode: '',
  regionCode: '',
  initialValues: undefined,
  destroyOnUnmount: true,
  renderPostcodeSearchBeforeAddressForm: false,
  useFormValidationErrorsAlertMessage: true,
  multiFormValidation: false,
  canEnterUKAddressInInternationalMode: false,
  loqateApiKey: undefined,
  preventLoqateScroll: false,
  shouldMockLoqate: false,
  jlpid: undefined,
  extraSearchAction: undefined,
  replaceGbTerritoryCountryCodes: true,
  combineExtraAddressLines: false,
  maxAddressLines: 4,
  getConfig: function getConfig() {},
  getLoqateMocks: function getLoqateMocks() {},
  onAddressFormSubmit: function onAddressFormSubmit() {},
  onSearchForAnotherAddressOverride: undefined,
  onEnterManualAddress: function onEnterManualAddress() {},
  onLoqateSearch: function onLoqateSearch() {},
  validateLoqateAddress: null,
  onLoqateTimeoutEnterAddressManuallyCallback: function onLoqateTimeoutEnterAddressManuallyCallback() {},
  onLoqateNetworkTimeoutCallback: function onLoqateNetworkTimeoutCallback() {},
  // actions
  resetAddressSearch: function resetAddressSearch() {},
  enterManualAddress: function enterManualAddress() {},
  resetFindAddressError: function resetFindAddressError() {},
  showSelectBelowOnEnterMessage: undefined,
  scrollValidationMessageIntoView: false
});
var _default = exports["default"] = (0, _reactRedux.connect)(function (state, ownProps) {
  var addressId = ownProps.addressId,
    disablePostcodeSearch = ownProps.disablePostcodeSearch;
  var stateObject = (0, _get["default"])(state, (0, _camelCase["default"])(addressId), {});
  var addressForm = (0, _get["default"])(state.form, ownProps.formId);
  var initialValues = _objectSpread(_objectSpread({}, ownProps.initialValues), stateObject.initialValues);
  var countryCode = (0, _get["default"])(addressForm, 'values.countryCode');
  var addressSearchInputId = ownProps.addressSearchInputId || 'addressSearch';
  return {
    findAddressError: stateObject.findAddressError,
    showAddressSearchForm: !disablePostcodeSearch && stateObject.showAddressSearchForm,
    initialValues: initialValues,
    internationalMode: stateObject.internationalMode,
    countryCode: countryCode,
    regionCode: ownProps.regionCode || '',
    showSelectBelowOnEnterMessage: state[addressSearchInputId].showSelectBelowOnEnterMessage
  };
}, {
  resetAddressSearch: _addressActions.resetAddressSearch,
  enterManualAddress: _addressActions.enterManualAddress,
  resetFindAddressError: _addressActions.resetFindAddressError
})(Address);